"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CrossElement = void 0;

var Point2D_1 = require("../../Core/Point2D");

var Element_1 = require("./Element");
/**
 * The cross element for selectors.
 */


var CrossElement = /*#__PURE__*/function (_Element_1$Element) {
  _inherits(CrossElement, _Element_1$Element);

  /**
   * Creates new `CrossElement`.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param boundRect - The parent bounding box for selection.
   */
  function CrossElement(paper, boundRect) {
    var _this;

    _classCallCheck(this, CrossElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CrossElement).call(this, paper, boundRect));

    _this.buildUIElements();

    _this.hide();

    return _this;
  }
  /**
   * The `x`-coordinate of the cross center.
   */


  _createClass(CrossElement, [{
    key: "boundToRect",

    /**
     * Bounds the cross center to the specified box.
     * @param rect - The bounding box.
     */
    value: function boundToRect(rect) {
      return new Point2D_1.Point2D(this.x, this.y).boundToRect(rect);
    }
    /**
     * Moves cross to specified point, applying bounding and taking into account square movement modificator.
     * @param p - The new cross center location.
     * @param rect - The bounding box.
     * @param square - The square movement flag.
     * @param ref - The reference point for square.
     */

  }, {
    key: "move",
    value: function move(p, boundRect) {
      var square = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var np = new Point2D_1.Point2D(p).boundToRect(boundRect);

      if (square) {
        var dx = Math.abs(np.x - ref.x);
        var vx = Math.sign(np.x - ref.x);
        var dy = Math.abs(np.y - ref.y);
        var vy = Math.sign(np.y - ref.y);
        var d = Math.min(dx, dy);
        np.x = ref.x + d * vx;
        np.y = ref.y + d * vy;
      }

      this.center.move(np);
      this.vl.node.setAttribute("x1", np.x.toString());
      this.vl.node.setAttribute("x2", np.x.toString());
      this.vl.node.setAttribute("y2", boundRect.height.toString());
      this.hl.node.setAttribute("y1", np.y.toString());
      this.hl.node.setAttribute("x2", boundRect.width.toString());
      this.hl.node.setAttribute("y2", np.y.toString());
    }
    /**
     * Resizes the cross element to specified `width` and `height`.
     * @param width - The new `width`.
     * @param height - The new `height`.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(CrossElement.prototype), "resize", this).call(this, width, height);

      this.vl.node.setAttribute("y2", height.toString());
      this.hl.node.setAttribute("x2", width.toString());
    }
    /**
     * Builds the visual presentation of the element.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      var verticalLine = this.paper.line(0, 0, 0, this.boundRect.height);
      var horizontalLine = this.paper.line(0, 0, this.boundRect.width, 0);
      this.node = this.paper.g();
      this.node.addClass("crossStyle");
      this.node.add(verticalLine);
      this.node.add(horizontalLine);
      this.hl = horizontalLine;
      this.vl = verticalLine;
      this.center = new Point2D_1.Point2D(0, 0);
    }
  }, {
    key: "x",
    get: function get() {
      return this.center.x;
    }
    /**
     * The `y`-coordinate of the cross center.
     */

  }, {
    key: "y",
    get: function get() {
      return this.center.y;
    }
  }]);

  return CrossElement;
}(Element_1.Element);

exports.CrossElement = CrossElement;